// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { deprecate, signout} from '~/redux/actions/user'

import { showAppModal } from '~/redux/actions/app'

// antd
import { Button, Modal } from 'antd'

const UserBind = props => {
    const { user } = props

    const handleBindPhone = event =>{
        props.showAppModal('PhoneBindModal')
        event.preventDefault()
    }

    const handleBindWechat = event =>{
        props.showAppModal('WechatBindModal')
        event.preventDefault()
    }

    const handleUnbindWechat = event =>{
        props.showAppModal('WechatUnbindModal')
        event.preventDefault()
    }

    const handleDeprecate = () => {
      Modal.confirm({
        title: "确认注销吗？注销后您将无法再用此账号登录，并移除该账号的所有数据，请谨慎操作！",
        onOk() {
          props.deprecate(props.token)
          props.signout()
        },
        onCancel() {},
      });
    }

    return (
        <div style={{ marginLeft: '10px' }}>
            { !user.phone &&  <Button onClick={handleBindPhone} className='ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost'>绑定手机号</Button> }
            { !user.wechat_openid &&  <Button onClick={handleBindWechat} className='ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost'>绑定微信</Button> }
            { user.wechat_openid &&  <Button onClick={handleUnbindWechat} className='ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost wechat-unbind-btn'>解绑微信</Button> }
            <Button onClick={handleDeprecate} className='ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost ml-5'>注销</Button>
        </div>

    )
}

const mapStateToProps = (state) => ({
    token: state.user.token,
    user: state.user.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
    showAppModal,
    deprecate,
    signout
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(UserBind)